import { EVENT as BLOCK_EVENTS } from '@classy/campaign-page-blocks'

export const EVENT = {
  ...BLOCK_EVENTS,
  ANALYTICS_TRACK_ADD_TO_CART: 'analytics.trackAddToCart',
  IAA_FETCH_AMOUNTS: 'iaa.fetch-amounts',
  PASSPORT_GET_CURRENCY_CONVERSION: 'passport.get-currency-conversion',
  SEARCH_GET_CAMPAIGN_PROGRESS_METRICS: 'search.get-campaign-progress-metrics',

  /**
   * Events for CustomEmbeddedCode iframes.
   *
   * Any page block or Whammy feature can dispatch CustomEvents that will be
   * forwarded to all registered CustomEmbeddedCode iframes.
   */
  CUSTOM_EMBEDDED_CODE_RESIZE_IFRAME: 'custom-embedded-code.resize-iframe',
  CUSTOM_EMBEDDED_CODE_CURRENCY_CHANGE: 'custom-embedded-code.currency-change',
}

export type Event = (typeof EVENT)[keyof typeof EVENT]
